export class OverlayRecord {
  Selected = false;

  // Common fields
  ID: string;
  LinkID: string;
  MRN: string;
  Facility: string;
  HealthPlans: string[];
  CreateDate?: string;
  ActionDate?: string;

  // Data version originating in HealthShare
  FirstName_HS?: string;
  LastName_HS?: string;
  DOB_HS?: string;
  Gender_HS?: string;
  Phone_HS?: string;
  AddressStreet_HS?: string;
  AddressCity_HS?: string;
  AddressState_HS?: string;
  AddressZip_HS?: string;

  // Data version originating in Verato message that generated the overlay
  FirstName_Verato?: string;
  LastName_Verato?: string;
  DOB_Verato?: string;
  Gender_Verato?: string;
  Phone_Verato?: string;
  AddressStreet_Verato?: string;
  AddressCity_Verato?: string;
  AddressState_Verato?: string;
  AddressZip_Verato?: string;

  static addSpaceIfBlank(overlay: OverlayRecord): void {
    setSpaceIfBlank('AddressStreet');
    setSpaceIfBlank('AddressCity');
    setSpaceIfBlank('AddressState');
    setSpaceIfBlank('AddressZip');

    function setSpaceIfBlank(prop) {
      if (overlay[prop + '_HS'] && !overlay[prop + '_Verato']) {
        overlay[prop + '_Verato'] = ' ';
      }
      else if (!overlay[prop + '_HS'] && overlay[prop + '_Verato']) {
        overlay[prop + '_HS'] = ' ';
      }
    }
  }

  constructor() {
  }
}
